<div>
  <div class="mb-4 flex items-center gap-2">
    <span class="inline-block px-3 py-1 rounded border border-blue-300 bg-gradient-to-br from-blue-100 to-blue-50 font-bold text-blue-700">X</span>
    <span class="text-sm text-gray-600">= Available date</span>
  </div>

  <div class="grid grid-cols-3 gap-4 relative mobile:grid-cols-1 mobile:gap-0 select-collection-date-calendar">

    @for (month of months; track month) {
      <div>
        @if (availableDates.length > 0) {
          <mat-card class="demo-inline-calendar-card h-full rounded-lg shadow-md">
            <mat-calendar [startAt]="month.startAt"
              [minDate]="today"
              [dateFilter]="dateIsSelectable"
              [dateClass]="dateClass"
              (selectedChange)="dateSelected($event)"
              [selected]="selectedDate"
              [headerComponent]="calendarHeader" >
            </mat-calendar>
          </mat-card>
        }
      </div>
    }

  </div>


</div>










<!--

-->